import { render, staticRenderFns } from "./StudentAchievement.vue?vue&type=template&id=0ab5f944&scoped=true&lang=pug&"
import script from "./StudentAchievement.vue?vue&type=script&lang=ts&"
export * from "./StudentAchievement.vue?vue&type=script&lang=ts&"
import style0 from "./StudentAchievement.vue?vue&type=style&index=0&id=0ab5f944&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5f944",
  null
  
)

export default component.exports